export default __webpack_public_path__ + "static/media/EH.514df58c.ico";